<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="widget">
          <div class="form-elements-sec">
            <div class="widget-title">
              <h3>Özellik Ekle</h3>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="university">Kategorisi</label>
                  <select class="form-control custom-input" v-model="category">
                    <option value selected disabled hidden>Seçiniz...</option>
                    <option
                      v-for="category in categories"
                      :key="category.id"
                      :value="category.id"
                    >{{ category.title }}</option>
                  </select>
                </div>
              </div>

              <div class="col-md-6">
                <div class="form-group">
                  <label for="title">Özellik</label>
                  <input type="text" v-model="title" class="form-control custom-input">
                </div>
              </div>

              <div class="col-md-12">
                <div class="form-group">
                  <label for></label>
                  <button class="btn btn-success pull-right" @click="addData">Kaydet</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      category: "",
      categories: [],
      api: "dorm_properties"
    };
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$Progress.start();
      this.axios.get(this.api + '/create').then(response => {
        this.categories = response.data;
        this.$Progress.finish();
      });
    },
    addData() {
      this.$Progress.start();
      this.axios
        .post(this.api, {
          category: this.category,
          title: this.title
        })
        .then(response => {
          if (response.status == 201) {
            this.$router.push({
              name: "dorm_properties.update",
              params: { id: response.data.id }
            });
          }
        });
    }
  }
};
</script>

<style scoped>
</style>